import React from 'react';

interface SummaryCardProps {
  title: string;
  value: number;
}

/** @see https://www.figma.com/design/uT1xEdzCrxp2ShMk1kXxve/Farmbot-Project---March-2023?node-id=6131-71086&t=IeMCOmjXkVmmAYls-4 */
function SummaryCard({ title, value }: SummaryCardProps) {
  return (
    <div className="CiboSubscriptionListPage-summary-card vertical-gap-4">
      <div className="body-copy">{title}</div>
      <div className="CiboSubscriptionListPage-summary-card-value">{value}</div>
    </div>
  );
}

export default SummaryCard;